/**
 * Formats a numeric amount to a string representation.
 * Removes trailing ".00" for whole dollar amounts.
 * 
 * @param amount - The numeric amount to format
 * @returns The formatted amount as a string (e.g., "5" for 5.00, "5.50" for 5.50)
 * 
 * @example
 * formatAmount(5) // Returns "5"
 * formatAmount(5.50) // Returns "5.50"
 * formatAmount(5.99) // Returns "5.99"
 */
export const formatAmount = (amount: number): string => {
  return `${amount.toFixed(2).replace(".00", "")}`
}